module.exports = __webpack_public_path__ + "img/face-fearful.cc971143.svg";